import * as React from "react";
import { Autocomplete, Box, FormControl, Grid, InputLabel, TextField } from "@mui/material";
import { CaretDown } from "@phosphor-icons/react/dist/ssr/CaretDown";
import { Controller } from "react-hook-form";

import { dayjs } from "@/lib/dayjs";
import { CustomDatePicker } from "@/components/customDatePicker/custom-date-picker";
import { CustomFormHelperError } from "@/components/customFormHelper/custom-form-helper-error";
import { CallBacks } from "@/components/customTable/call-backs";
import { SchedulePicker } from "@/components/schedule/schedule-picker";

export function Scheduling({
	isEdit,
	control,
	errors,
	setValue,
	scheduling,
	callBacks,
	clearErrors,
}: {
	isEdit: boolean;
	control: any;
	errors: any;
	setValue: any;
	scheduling: any;
	callBacks: any;
	clearErrors: any;
}) {
	return (
		<Grid container spacing={2}>
			<Grid size={{ xs: 12, md: 12 }}>
				<Controller
					control={control}
					name="timezone"
					rules={{
						required: "Timezone is required",
					}}
					render={({ field }) => (
						<FormControl error={Boolean(errors.timezone)} fullWidth required>
							<Autocomplete
								options={Intl.supportedValuesOf("timeZone")}
								value={field.value || null}
								onChange={(_, newValue) => field.onChange(newValue)}
								popupIcon={<CaretDown size={18} />}
								slotProps={{
									chip: { color: "primary" },
									paper: {
										sx: {
											fontSize: "14px !important",
										},
									},
									popper: {
										sx: {
											"& .MuiAutocomplete-option": {
												margin: "4px 0 !important",
												fontSize: "14px !important",
											},
										},
									},
								}}
								sx={{
									width: "100%",
									"& .MuiInputBase-input": {
										cursor: "pointer",
										fontSize: "16px !important",
									},
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										label="Timezone"
										placeholder="Select a timezone"
										error={Boolean(errors.timezone)}
										required
									/>
								)}
							/>
							{errors.timezone ? <CustomFormHelperError text={(errors.timezone.message as string) || ""} /> : null}
						</FormControl>
					)}
				/>
			</Grid>

			<Grid
				size={{
					md: 6,
					xs: 12,
				}}
			>
				<Controller
					control={control}
					name="startAt"
					render={({ field, fieldState }) => (
						<FormControl error={Boolean(fieldState.error)} fullWidth>
							<CustomDatePicker
								{...field}
								label="Start At"
								minDate={dayjs()}
								setValue={field.onChange}
								error={Boolean(fieldState.error)}
							/>
							{fieldState.error && <CustomFormHelperError text={fieldState.error.message || ""} />}
						</FormControl>
					)}
				/>
			</Grid>
			<Grid
				size={{
					md: 6,
					xs: 12,
				}}
			>
				<Controller
					control={control}
					name="endAt"
					render={({ field, fieldState }) => (
						<FormControl error={Boolean(fieldState.error)} fullWidth>
							<CustomDatePicker
								{...field}
								label="End At"
								minDate={dayjs()}
								setValue={field.onChange}
								error={Boolean(fieldState.error)}
							/>
							{fieldState.error && <CustomFormHelperError text={fieldState.error.message || ""} />}
						</FormControl>
					)}
				/>
			</Grid>

			<Grid
				size={{
					md: 12,
					xs: 12,
				}}
			>
				<InputLabel>Scheduling</InputLabel>
				<Box sx={{ p: 2, mt: 1, border: "1px solid var(--mui-palette-divider)", borderRadius: 1 }}>
					<SchedulePicker
						value={scheduling || []}
						onChange={(value) => setValue("scheduling", value)}
						showSummary={true}
						maxSlotsPerDay={24}
					/>
				</Box>
			</Grid>

			{isEdit && (
				<Grid
					size={{
						md: 12,
						xs: 12,
					}}
				>
					<InputLabel>Call Backs</InputLabel>
					<Box sx={{ p: 2, mt: 1, border: "1px solid var(--mui-palette-divider)", borderRadius: 1 }}>
						<CallBacks
							callBacks={callBacks}
							errors={errors}
							onChange={(value) => setValue("callBacks", value)}
							clearErrors={clearErrors}
						/>
					</Box>
				</Grid>
			)}
		</Grid>
	);
}
